import { ExpandLess, ExpandMore, Save } from "@mui/icons-material";
import {
  Box,
  Button,
  Drawer,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../../../../context";
import { AppendToStella } from "../ClinicalNotesAPI/ClinicalNoteAPIManager";
import { useSnackbar } from "notistack";
import { useAuth } from "../../../../auth";
import AuditLogs from "./AuditLogs";
import { set } from "date-fns";
import DownloadPrescription from "../Dialogs/DownloadPrescription";
import { getUsage, isAusDomain } from "../lib/utils";
import LetterTemplates from "./LetterTemplates";
import sign from "jwt-encode";
import SubscriptionAlertModal from "../../modals/SubscriptionAlertModal";

function Actions({ downloadPDF }) {
  const { expertClinicalNotesData, setExpertClinicalNotesData } =
    useContext(AppContext);
  const [auditOpen, setAuditOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { enqueueSnackbar } = useSnackbar();
  const restricteddownload = ["us", "united states"];
  const [downloadPrescription, setDownloadPrescription] = useState(false);
  const [letterTemplateOpen, setLetterTemplateOpen] = useState(false);
  const { currentUser } = useAuth();
  const [mediRecordUrl, setMediRecordUrl] = useState(
    "https://app.medirecords.com/login.html"
  );
  const [pdfUsageModal, setPdfUsageModal] = useState(false);
  const [letterUsageModal, setLetterUsageModal] = useState(false);
  const toggleDrawer = (newOpen) => {
    setAuditOpen(newOpen);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleRefresh = () => {
    setExpertClinicalNotesData((prevData) => ({
      ...prevData,
      askStellaConversation: "init",
    }));
    handleClose();
    AppendToStella({
      ...expertClinicalNotesData?.headerData,
    }).then((res) => {
      if (res?.error) {
        enqueueSnackbar(res?.message, { variant: "info" });
        setExpertClinicalNotesData((prevData) => ({
          ...prevData,
          askStellaConversation: "mid",
        }));
        return;
      }
      setExpertClinicalNotesData((prevData) => ({
        ...prevData,
        askStellaConversation: "end",
      }));
    });
  };
  const handleEditTemplate = () => {
    setExpertClinicalNotesData((prevData) => ({
      ...prevData,
      editTemplate: true,
    }));
    handleClose();
  };
  const handleSaveTemplate = () => {
    const newUpdatedTemplate = expertClinicalNotesData?.data?.template?.map(
      (item) => item.name
    );
    const previousTemplate = expertClinicalNotesData?.template?.map(
      (item) => item.name
    );
    const updatedTemplate = newUpdatedTemplate.filter(
      (item) => !previousTemplate.includes(item)
    );
    const updatedTemplate2 = previousTemplate.filter(
      (item) => !newUpdatedTemplate.includes(item)
    );

    if (updatedTemplate?.length > 0) {
      updatedTemplate?.map((item) => {
        expertClinicalNotesData.socketRef.current.send(
          JSON.stringify({
            action_type: "visibility_changed",
            details: {
              field_name:
                item?.charAt(0)?.toUpperCase() +
                item?.slice(1)?.replace(/_/g, " "),
              visibility: "visible",
            },
            user_id: expertClinicalNotesData?.headerData?.user_id,
            expert_id: expertClinicalNotesData?.headerData?.expert_id,
          })
        );
      });
    }
    if (updatedTemplate2?.length > 0) {
      updatedTemplate2?.map((item) => {
        expertClinicalNotesData.socketRef.current.send(
          JSON.stringify({
            action_type: "visibility_changed",
            details: {
              field_name:
                item?.charAt(0)?.toUpperCase() +
                item?.slice(1)?.replace(/_/g, " "),
              visibility: "hidden",
            },
            user_id: expertClinicalNotesData?.headerData?.user_id,
            expert_id: expertClinicalNotesData?.headerData?.expert_id,
          })
        );
      });
    }
    expertClinicalNotesData.socketRef.current.send(
      JSON.stringify({
        header: expertClinicalNotesData?.headerData,
        session_data: expertClinicalNotesData?.data,
      })
    );
    setExpertClinicalNotesData((prevData) => ({
      ...prevData,
      editTemplate: false,
    }));

    handleClose();
  };
  useEffect(() => {
    if (expertClinicalNotesData?.headerData?.user_id && isAusDomain()) {
      fetchMediRecordsDetails();
    }
  }, [expertClinicalNotesData?.headerData?.user_id]);
  async function fetchMediRecordsDetails() {
    try {
      const token = sign(
        { user_id: `${expertClinicalNotesData?.headerData?.user_id}` },
        process.env.REACT_APP_JWT_ENCODE_SECRET || ""
      );
      const response = await fetch(
        "https://ws-stella.unitedwecare.com/api/v1/app/user/medirecords/details",
        {
          method: "GET",
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (data?.success) {
        setMediRecordUrl(data.url);
      } else {
        setMediRecordUrl("https://app.medirecords.com/login.html");
      }
    } catch (error) {
      console.error("Error fetching MediRecords details:", error);
    }
  }

  // console.log(":::::::: CURRENT USER :::: ", currentUser?.Emailid?.includes("@asksam.com.au"))

  return (
    <>
      <SubscriptionAlertModal
        h1={"Upgrade to Keep Using Letter Templates"}
        h2={
          "You can't create any more letters this month. To keep using our letter templates, please upgrade to a better plan."
        }
        cta1={"Upgrade Now"}
        cta2={"Upgrade Later"}
        isOpen={letterUsageModal}
        onClose={() => setLetterUsageModal(false)}
      />
      <SubscriptionAlertModal
        h1={"Upgrade to Download Clinical Notes"}
        h2={
          "You have exhausted all your credits for this month. To Download more Clinical Notes, please upgrade to a better plan."
        }
        cta1={"Upgrade Now"}
        cta2={"Upgrade Later"}
        isOpen={pdfUsageModal}
        onClose={() => setPdfUsageModal(false)}
      />
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        variant="outlined"
        size="small"
        style={{
          color: "#000",
          boxShadow: "none",
          fontSize: "16px",
          fontWeight: "500",
          textTransform: "capitalize",
        }}
        className=" text-capitalize border rounded-2 border-2 "
      >
        Actions {open ? <ExpandLess /> : <ExpandMore />}
      </Button>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {/* <MenuItem onClick={handleClose}>None</MenuItem> */}
        {/* {!expertClinicalNotesData?.data?.submitted &&
          expertClinicalNotesData?.headerData?.user_id && (
            <MenuItem onClick={handleRefresh}>Refresh</MenuItem>
          )} */}
        {/* hidden needs to update the new fields */}
        {expertClinicalNotesData?.headerData?.user_id && (
          <MenuItem
            onClick={async () => {
              handleClose();
              const profileData = JSON.parse(localStorage.getItem("profile")); // Parse profileData if it's stored as a string

              const cred = sign(
                { user_id: `${profileData?.UserId}` },
                process.env.REACT_APP_JWT_ENCODE_SECRET || ""
              );
              // Usage limits apply to all users (like AUS system)
              const usage = await getUsage(
                "download_clinical_notes",
                profileData?.UserId,
                cred
              );
              if (!usage.success) return;
              if (!usage?.data?.value) {
                setPdfUsageModal(true);
                return;
              }

              downloadPDF();
            }}
          >
            Download PDF
          </MenuItem>
        )}
        {expertClinicalNotesData?.headerData?.user_id && (
          <MenuItem
            onClick={() => {
              handleClose();
              toggleDrawer(true);
            }}
          >
            Audit Trail
          </MenuItem>
        )}
        {expertClinicalNotesData?.headerData?.user_id && currentUser?.Emailid?.includes("@asksam.com.au") && isAusDomain() && (
          <MenuItem
            onClick={() => {
              handleClose();
              window.open(mediRecordUrl, "_blank");
            }}
          >
            Prescribe in MediRecords
          </MenuItem>
        )}
        {/* Commented To unhide */}
        {/* {!expertClinicalNotesData?.data?.submitted &&
          expertClinicalNotesData?.headerData?.user_id && (
            <MenuItem onClick={handleEditTemplate}>Edit Template</MenuItem>
          )} */}
        {/* {expertClinicalNotesData?.headerData?.user_id && (
          <MenuItem
            onClick={() => {
              handleClose();
              setDownloadPrescription(true);
            }}
          >
            Download Prescription
          </MenuItem>
        )} */}{" "}
        {expertClinicalNotesData?.headerData?.user_id && isAusDomain() && (
          <MenuItem
            onClick={async () => {
              handleClose();
              const profileData = JSON.parse(localStorage.getItem("profile")); // Parse profileData if it's stored as a string

              const cred = sign(
                { user_id: `${profileData?.UserId}` },
                process.env.REACT_APP_JWT_ENCODE_SECRET || ""
              );
              // Usage limits apply to all users (like AUS system)
              const usage = await getUsage(
                "letter_templates",
                profileData?.UserId,
                cred
              );
              if (!usage.success) return;
              if (!usage?.data?.value) {
                setLetterUsageModal(true);
                return;
              }

              setLetterTemplateOpen(true);
            }}
          >
            Letter Templates
          </MenuItem>
        )}
      </Menu>

      <Drawer
        open={auditOpen}
        onClose={() => {
          toggleDrawer(false);
        }}
      >
        <Box className="p-2 p-md-4 audit-drawer " role="presentation">
          <AuditLogs
            close={() => {
              toggleDrawer(false);
            }}
          />
        </Box>
      </Drawer>
      <Drawer
        open={letterTemplateOpen}
        onClose={() => {
          setLetterTemplateOpen(false);
        }}
        anchor="bottom"
      >
        <Box className="  letter-template " role="presentation">
          <LetterTemplates
            userData={expertClinicalNotesData}
            close={() => {
              setLetterTemplateOpen(false);
            }}
          />
        </Box>
      </Drawer>
      <DownloadPrescription
        open={downloadPrescription}
        close={() => setDownloadPrescription(false)}
      />
      {expertClinicalNotesData?.editTemplate && (
        <Tooltip arrow title="Save Template">
          <IconButton
            onClick={handleSaveTemplate}
            style={{ bottom: "80px", zIndex: "1000", background: "white" }}
            className=" position-fixed border shadow  end-0 mx-5 "
          >
            <Save sx={{ fontSize: "50px", color: "var(--primary-color)" }} />
          </IconButton>
        </Tooltip>
      )}
    </>
  );
}

export default Actions;
